export interface FooterProps {
  ergeonUrl: string;
  projectsGalleryUrl?: string;
}

export interface FooterMenuItem {
  label: string;
  href: string;
}

export interface FooterMenuColumn {
  title: string;
  items: FooterMenuItem[];
}

export interface FooterMenuProps {
  columns: FooterMenuColumn[];
}

export interface FooterTermsProps {
  ergeonUrl: string;
}

export interface SocialLinksProps {
  className?: string;
}
